import { browserHistory } from 'react-router';

import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';
import { openErrorDialog } from '../dialog/dialogActions';
import SessionApi from '../../apis/session';
import { clearLoggedIn } from '../../lib/auth';


// session actions are not tied to any reducer, the state we need to read from is handled in the child components.
export const loginRequest = (data, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.LOGIN_REQUEST,
      api: SessionApi.loginRequest,
      param: data,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. This also handles catch() errors.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
    }));
  };
};

export const logoutRequest = (successCb, errorCb) => {
  return dispatch => {
    // Kill state regardless of success/error - handled in the rootReducer
    dispatch({ type: types.LOGOUT_REQUEST });

    dispatch(execApi({
      type: types.LOGOUT_REQUEST,
      api: SessionApi.logoutRequest,
      successCallback: response => {
        clearLoggedIn();

        if (successCb) {
          successCb(response);
        } else if ("/" !== localStorage.logoutUrl) {
          window.location.href = localStorage.logoutUrl;
        } else {
          browserHistory.push("/");
        }
      },
      // Our 'success: false' response object. This also handles catch() errors.
      errorCallback: response => {
        if (errorCb) {
          errorCb(response);
        } else {
          dispatch(openErrorDialog({
            title: response.message.title,
            content: response.message.body,
          }));
        }
      },
    }));
  };
};

export const verifyCode = (code, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.VERIFY_CODE_REQUEST,
      api: SessionApi.verifyCode,
      param: code,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. This also handles catch() errors.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
    }));
  };
};

export const verifyDob = (dob, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.VERIFY_DOB_REQUEST,
      api: SessionApi.verifyDob,
      param: dob,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. This also handles catch() errors.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/session/sessionActions.js